import React from 'react';
import { Link } from 'react-router-dom';

interface OpportunityCardProps {
  title: string;
  description: string;
  icon: React.ElementType;
  isCustom?: boolean;
}

const OpportunityCard: React.FC<OpportunityCardProps> = ({ 
  title, 
  description, 
  icon: Icon,
  isCustom = false
}) => (
  <div className="bg-[#2A2A2A] rounded-xl p-6 border border-gray-800 hover:border-brand/50 transition-all duration-300 hover:shadow-[0_0_15px_rgba(62,207,142,0.3)] hover:-translate-y-1">
    <div className="flex items-start gap-4">
      <div className="p-3 bg-brand/10 rounded-lg">
        <Icon className="w-6 h-6 text-brand" />
      </div>
      <div className="flex-1">
        <h3 className="text-lg font-semibold text-content-primary mb-2">{title}</h3>
        <p className="text-content-secondary">
          {description}
          {isCustom && (
            <>
              {' '}
              <Link to="/contact" className="text-brand hover:text-brand-light">
                Contact Us
              </Link>
            </>
          )}
        </p>
      </div>
    </div>
  </div>
);

export default OpportunityCard;